import PersonAddIcon from '@atlaskit/icon/core/person-add';
import * as React from 'react';

export function SvgUsersAdd() {
  return <PersonAddIcon label="" testId="ads-refreshed-icon" />;
}
